export class FilterDateError extends Error {
  public constructor() {
    super('filter date value is invalid')
  }
}